import { dateInTheFuture } from './date';
const CUSTOMER_SEGMENT_COOKIE_NAME = 'isBusinessCustomer';

const writeCustomerSegmentCookie = event => {
  if (!event.target.dataset.allowdefault) {
    event.preventDefault();
  }
  const element = event.currentTarget;
  const isBusiness = element.getAttribute('data-isbusiness') === 'true';
  const date = dateInTheFuture();
  document.cookie = `${CUSTOMER_SEGMENT_COOKIE_NAME}=${isBusiness}; path=/;expires=${date}`;
  if (!event.target.dataset.allowdefault) {
    window.location.reload(true);
  }
};

export function init() {
  document
    .querySelectorAll('.c-customer-segment__btn')
    .forEach(x => x.addEventListener('click', writeCustomerSegmentCookie));
}
